import React from 'react';
import { pieceNames } from '../constants/pieces';
import { getBattleInfo } from '../gameLogic/battles';

export default function GameSidebar({
  phase, turn, selected, squares, moveHistory, playerPositions,
  p1PiecesToPlace, p2PiecesToPlace,
  onRandomize, onSurrender, onNewGame,
  myPlayer, // optional: set in online mode so move history hides opponent pieces correctly
  onHome,
}) {
  const p1Count = playerPositions.filter(p => p === "1").length;
  const p2Count = playerPositions.filter(p => p === "2").length;

  let piecesToPlace = [];
  let setup = false;
  if (phase === "player1_setup" && (!myPlayer || myPlayer === "1")) {
    piecesToPlace = p1PiecesToPlace;
    setup = true;
  } else if (phase === "player2_setup" && (!myPlayer || myPlayer === "2")) {
    piecesToPlace = p2PiecesToPlace;
    setup = true;
  }

  const recentHistory = moveHistory.slice(-10).reverse();

  // In online mode, myPlayer is always the viewer.
  // In local mode, the viewer alternates with turn ("wait2" means P1 is looking).
  const viewerPlayer = myPlayer || ((turn === "1" || turn === "wait2") ? "1" : "2");

  return (
    <div className="game-sidebar">
      {phase !== "end" && (
        <div className="piece-counts">
          <div>Player 1: {p1Count} pieces remaining</div>
          <div>Player 2: {p2Count} pieces remaining</div>
        </div>
      )}

      {phase === "game" && selected !== null && (() => {
        const selectedPiece = squares[selected];
        const { beats, losesTo, ties } = getBattleInfo(selectedPiece);
        return (
          <div className="battle-info">
            <div className="battle-info-title">Selected: {pieceNames[selectedPiece]}</div>
            {beats.length > 0 && (
              <div className="battle-info-section">
                <span className="battle-info-label win">Defeats:</span>
                <span>{beats.map(p => pieceNames[p]).join(", ")}</span>
              </div>
            )}
            {ties.length > 0 && (
              <div className="battle-info-section">
                <span className="battle-info-label tie">Draws:</span>
                <span>{ties.map(p => pieceNames[p]).join(", ")}</span>
              </div>
            )}
            {losesTo.length > 0 && (
              <div className="battle-info-section">
                <span className="battle-info-label lose">Loses to:</span>
                <span>{losesTo.map(p => pieceNames[p]).join(", ")}</span>
              </div>
            )}
          </div>
        );
      })()}

      {setup && (
        <div className="setup-sidebar">
          <div className="setup-current">
            Current Piece: {piecesToPlace[0] ? pieceNames[piecesToPlace[0]] : "All placed!"}
          </div>
          <div className="setup-list">
            {piecesToPlace.map((piece, idx) => (
              <div key={idx}>{pieceNames[piece]}</div>
            ))}
          </div>
          <button onClick={onRandomize}>Randomize Setup</button>
        </div>
      )}

      {phase === "game" && onSurrender && (
        <button className="surrender-btn" onClick={onSurrender}>
          Surrender
        </button>
      )}

      {phase !== "end" && onNewGame && (
        <button className="new-game-btn" onClick={onNewGame}>
          New Game
        </button>
      )}

      {onHome && (
        <button className="home-exit-btn" onClick={onHome}>⌂ Home</button>
      )}

      {moveHistory.length > 0 && (
        <div className="move-history">
          <div className="move-history-title">Move History</div>
          {recentHistory.map((entry, idx) => {
            const pieceName = entry.turn === viewerPlayer ? pieceNames[entry.piece] : "???";
            let text;
            if (entry.type === "move") {
              text = `P${entry.turn}: ${pieceName} moved`;
            } else if (entry.outcome === "attacker") {
              text = `P${entry.turn}: ${pieceName} captured opponent`;
            } else if (entry.outcome === "defender") {
              text = `P${entry.turn}: ${pieceName} lost battle`;
            } else {
              text = `P${entry.turn}: ${pieceName} tied`;
            }
            return <div key={idx}>{text}</div>;
          })}
        </div>
      )}
    </div>
  );
}
